/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If you would like to propose
 * a change to this component, please reach out to a
 * frontend engineer.
 *
 * @author Asa Ayers <asa.ayers@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';
import styles from './tooltip.scss';

// Assigning these to strings allows interoperability with JavaScript.
export enum ArrowDirection {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}

export type TooltipUIProps = {
  children: React.ReactNode
  kind?: 'small'
  className?: string,
  style?: React.CSSProperties,
  arrow?: ArrowDirection,
}

function TooltipImpl(props: TooltipUIProps, ref?: React.Ref<any>) {
  return (
    <div
      ref={ref}
      style={props.style}
      className={classnames(styles.tooltip, props.className, {
        [styles.small]: props.kind === 'small',
        [styles.top]: props.arrow === ArrowDirection.Top,
        [styles.bottom]: props.arrow === ArrowDirection.Bottom || !props.arrow,
        [styles.left]: props.arrow === ArrowDirection.Left,
        [styles.right]: props.arrow === ArrowDirection.Right,
      })}
    >
      {props.children}
    </div>
  );
}

const TooltipUI = React.forwardRef(TooltipImpl);
export default TooltipUI;

/**
 * This component provides a 0x0 div that you can position and the tooltip will
 * point at it.
 */
export function TooltipPoint({ className, style, ...props }: TooltipUIProps) {
  return (
    <div className={classnames(className, styles.point)} style={style}>
      <TooltipUI {...props} />
    </div>
  );
}
